module.exports = __webpack_public_path__ + "img/北京库房.ac648c6e.jpg";